import type { JSX, ReactNode } from "react";
import { useFps } from "@/hooks/useFps";
import { useSceneStore } from "@/state/useSceneStore";

interface Props {
  route: string;
  onClose: () => void;
  children: ReactNode;
}

export const MonitorFrame = ({
  route,
  onClose,
  children,
}: Props): JSX.Element => {
  const fps = useFps();
  const quality = useSceneStore((s) => s.quality);
  const path = route.replace(/^#?\/?/, "");
  return (
    <div className="relative h-full w-full overflow-hidden border-2 border-ink2 bg-bg0 font-mono text-ink0">
      <div className="pointer-events-none absolute inset-0 border border-rule" />
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg, transparent 0 2px, rgba(122,240,168,0.06) 2px 3px)",
        }}
      />
      <header className="flex items-center justify-between border-b border-rule px-3 py-1 text-[10px] uppercase tracking-widest">
        <span>ADAM@KOTLORZ - /{path}</span>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close monitor view"
          className="text-ink2 hover:text-phosphor"
        >
          ×
        </button>
      </header>
      <main
        role="region"
        aria-label={`Monitor route ${path}`}
        className="h-[calc(100%-44px)] overflow-auto p-6"
      >
        {children}
      </main>
      <footer className="absolute inset-x-0 bottom-0 border-t border-rule px-3 py-1 text-[10px] uppercase tracking-widest">
        READY · {fps} fps · {quality}
      </footer>
    </div>
  );
};
